import script from "./NavigationBarMember2.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationBarMember2.vue?vue&type=script&setup=true&lang=js"

import "./NavigationBarMember2.vue?vue&type=style&index=0&id=6b7bef04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7bef04"]])

export default __exports__